import { getIn, FormikProps } from 'formik'
import { Schema } from 'yup'

import { AnyObj } from '../../../mas-sales-front/src/modules/testing-utils/testing-helpers'

export const hasFormikError = (form: FormikProps<any>, name: string): boolean =>
  getIn(form.errors, name) !== undefined && !!getIn(form.touched, name)

export function mapYupToFormikErrors(err: { inner: any[] }) {
  return err.inner
    .filter((i: { message: any }) => !!i.message)
    .reduce(
      (curr: any, next: { path: any; errors: any[] }) => ({
        ...curr,
        [next.path]: next.errors[0],
      }),
      {},
    )
}

export function validateSchema<T>(values: unknown, schema: Schema<T>, context?: AnyObj) {
  return schema
    .validate(values, {
      abortEarly: false,
      strict: false,
      context,
    })
    .then(() => {
      return {}
    })
    .catch(mapYupToFormikErrors)
}
